import ItemCard from '../../../components/item-card.gts';
import RecipeCard from '../../../components/recipe-card.gts';
import { VerticalCollection } from '@html-next/vertical-collection';
import InfiniteScrollTrigger from '../../../components/infinite-scroll-trigger.gts';
import type { TOC } from '@ember/component/template-only';
import type ItemsIndexResultsRoute from '../../../routes/explore/index/results.ts';
import type ItemsIndexResultsController from '../../../controllers/explore/index/results.ts';
import pullToRefresh from '../../../modifiers/pull-to-refresh.ts';
import responsiveColumns from '../../../modifiers/responsive-columns.ts';

interface Signature {
  Args: {
    model: Awaited<ReturnType<ItemsIndexResultsRoute['model']>>;
    controller: ItemsIndexResultsController;
  };
}

const ItemsIndexResults: TOC<Signature> = <template>
  <div {{pullToRefresh @controller.refresh}}>
    <div
      {{responsiveColumns
        onChange=@controller.setColumnCount
        breakpoints=@controller.gridBreakpoints
      }}
    >
      {{#if @controller.isRecipeMode}}
        {{! Recipes grid }}
        {{#if @controller.recipes.length}}
          <VerticalCollection
            @items={{@controller.recipeRows}}
            @estimateHeight={{172}}
            @staticHeight={{true}}
            @containerSelector="body"
            @tagName="div"
            as |row|
          >
            <div class={{@controller.gridRowClass}}>
              {{#each row as |recipe|}}
                <RecipeCard @recipe={{recipe}} />
              {{/each}}
            </div>
          </VerticalCollection>
        {{else}}
          <div class="text-base-content/60 py-12 text-center">
            No recipes found.
          </div>
        {{/if}}
      {{else}}
        {{! Items grid }}
        {{#if @controller.items.length}}
          <VerticalCollection
            @items={{@controller.rows}}
            @estimateHeight={{172}}
            @staticHeight={{true}}
            @containerSelector="body"
            @tagName="div"
            as |row|
          >
            <div class={{@controller.gridRowClass}}>
              {{#each row as |item|}}
                <ItemCard @item={{item}} />
              {{/each}}
            </div>
          </VerticalCollection>
        {{else}}
          <div class="text-base-content/60 py-12 text-center">
            No items found.
          </div>
        {{/if}}
      {{/if}}
    </div>

    <InfiniteScrollTrigger
      @hasMore={{@controller.hasMore}}
      @isLoading={{@controller.isLoadingMore}}
      @onLoadMore={{@controller.loadMore}}
    />
  </div>
</template>;

export default ItemsIndexResults;
